__turbopack_context__.v({
  "check-icon": "ConfirmationModal-module-scss-module__Gw-BfW__check-icon",
  "dialog-wrapper": "ConfirmationModal-module-scss-module__Gw-BfW__dialog-wrapper",
  "feature-item-list": "ConfirmationModal-module-scss-module__Gw-BfW__feature-item-list",
  "headline": "ConfirmationModal-module-scss-module__Gw-BfW__headline",
  "hero": "ConfirmationModal-module-scss-module__Gw-BfW__hero",
  "modal-title": "ConfirmationModal-module-scss-module__Gw-BfW__modal-title",
  "picked-confirmation": "ConfirmationModal-module-scss-module__Gw-BfW__picked-confirmation",
  "picked-confirmation-body": "ConfirmationModal-module-scss-module__Gw-BfW__picked-confirmation-body",
  "picked-confirmation-body-content": "ConfirmationModal-module-scss-module__Gw-BfW__picked-confirmation-body-content",
  "subdomain": "ConfirmationModal-module-scss-module__Gw-BfW__subdomain",
  "underlay": "ConfirmationModal-module-scss-module__Gw-BfW__underlay",
});
